import { render } from "./users-list-modal.vue?vue&type=template&id=270f0580&scoped=true"
import script from "./users-list-modal.vue?vue&type=script&lang=js"
export * from "./users-list-modal.vue?vue&type=script&lang=js"

import "./users-list-modal.vue?vue&type=style&index=0&id=270f0580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270f0580"]])

export default __exports__